import { useEffect, useState } from "react";
import Gradient from "javascript-color-gradient";
import { edgeParameters, parametersNames, parameterPrecision } from "../config/config";
const gradientArray = new Gradient()
  //.setColorGradient("#3F2CAF", "#e9446a")
  .setColorGradient("#00FF00", "#0000FF", "#FF0000")
  .setMidpoint(20)
  .getColors();

function createLine(s, t, caption, value, maxValue) {
  const maxGrad = 19.0;
  const color = value != null ? gradientArray[Math.ceil((maxGrad / maxValue) * value)] : "#000000";
  const width = value != null ? 2 : 1;

  return new window.ymaps.Polyline(
    [
      [s.y ?? s.lat, s.x ?? s.lon],
      [t.y ?? t.lat, t.x ?? t.lon],
    ],
    {
      balloonContentBody: caption
    },
    {
      draggable: false,
      strokeColor: color,
      strokeWidth: width,
      // Первой цифрой задаем длину штриха. Второй — длину разрыва.
      //strokeStyle: "1 5",
    }
  );
}
export const RoadsLayout = ({ map, graph, parameter, enabled }) => {
  const [roads, setRoads] = useState(null);

  useEffect(() => {
    const collection = new window.ymaps.GeoObjectCollection();
    var maxValue = 0.0;

    if(parameter) {
      graph.forEachEdge((e, attrs) => {
        const value = parseFloat(attrs[parameter]);
        if (value > maxValue) {
          maxValue = value;
        }
      });
    }

    graph.forEachEdge((e, attrs, s, t, sAttr, tAttr) => {
      var value = 0
      if(parameter && attrs[parameter]) {
        value = attrs[parameter]
      }
      var caption = ""
      //console.log(attrs)
      for(var key in attrs) {
        if(edgeParameters.includes(key)) {
          const precision = parameterPrecision[key]
          caption += "<b>" + parametersNames[key] + " = </b>" + (precision ? attrs[key].toFixed(precision) : attrs[key]);
          caption += "<br/>"
        }
      }
      collection.add(createLine(sAttr, tAttr, caption, parameter ? value : null, maxValue));
    });
    setRoads(collection);
  }, []);

  useEffect(() => {
    if (roads && enabled) {
      map.geoObjects.add(roads);
    } else {
      map.geoObjects.remove(roads);
    }
  }, [roads, enabled]);
  return null;
};
